export default __webpack_public_path__ + "static/commercial_dumpster_service_guide-18ff4991c738ca34e3dff7b561870e08.png";